// src/lib/cognito.js
import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from "amazon-cognito-identity-js";

// ✅ Debug — Env doğrulama (istersen sonra silebilirsin)
console.log("✅ ENV CHECK (cognito.js):", {
  region: import.meta.env.VITE_REGION,
  UserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  ClientId: import.meta.env.VITE_COGNITO_CLIENT_ID
});

// ✅ Session Storage fallback (Safari/Private Mode desteği)
const memoryStore = {};
const Storage = {
  setItem(key, value) {
    try { sessionStorage.setItem(key, value); }
    catch { memoryStore[key] = value; }
  },
  getItem(key) {
    try { return sessionStorage.getItem(key); }
    catch { return memoryStore[key] || null; }
  },
  removeItem(key) {
    try { sessionStorage.removeItem(key); }
    catch { delete memoryStore[key]; }
  }
};

// ✅ Cognito UserPool — DOĞRU ENV keys ile
const pool = new CognitoUserPool({
  UserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  ClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  Storage,
});

// ✅ Login
export function signIn({ username, password }) {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: username, Pool: pool, Storage });
    const authDetails = new AuthenticationDetails({ Username: username, Password: password });

    user.authenticateUser(authDetails, {
      onSuccess: (session) => resolve({ type: "SUCCESS", session, user }),
      onFailure: reject,
      newPasswordRequired: (userAttributes) =>
        resolve({ type: "NEW_PASSWORD_REQUIRED", user, userAttributes }),
    });
  });
}

// ✅ Challenge: New Password Required
export function completeNewPassword(user, newPassword, requiredAttributes = {}) {
  return new Promise((resolve, reject) => {
    user.completeNewPasswordChallenge(newPassword, requiredAttributes, {
      onSuccess: (session) => resolve({ type: "SUCCESS", session, user }),
      onFailure: reject,
    });
  });
}

// ✅ Current user
export function getCurrentUser() {
  return pool.getCurrentUser();
}

// ✅ JWT Token — ASYNC & GARANTİLİ ✅
export function getIdToken() {
  const user = getCurrentUser();
  if (!user) return Promise.reject(new Error("No user session"));

  return new Promise((resolve, reject) => {
    user.getSession((err, session) => {
      if (err || !session?.isValid()) {
        return reject(new Error("Invalid or expired session"));
      }
      const token = session.getIdToken().getJwtToken();
      resolve(token);
    });
  });
}

// ✅ Kullanıcı ismini döndüren yardımcı fonksiyon
export async function getDisplayName() {
  try {
    const token = await getIdToken();
    const payload = JSON.parse(atob(token.split(".")[1]));

    return (
      payload.name ||
      payload.given_name ||
      payload.preferred_username ||
      (payload.email ? payload.email.split("@")[0] : "User")
    );
  } catch {
    return "User";
  }
}

// ✅ Logout
export function signOut() {
  const user = getCurrentUser();
  if (user) user.signOut();
}

// ✅ Session Oturum Kontrolü
export async function isAuthed() {
  const user = getCurrentUser();
  if (!user) return false;

  return new Promise((resolve) => {
    user.getSession((err, session) => {
      if (err || !session?.isValid()) return resolve(false);
      resolve(true);
    });
  });
}